import React from "react";

import { Button, ButtonGroup, TooltipWrapper } from "@zapier/design-system";

import { useSize } from "@zapier/checkout/esm/hooks";

type ChangePlanButtonsProps = {
  isDisabled: boolean;
  onCancelChangePlan: (e: React.MouseEvent<HTMLElement>) => void;
  onChangePlan: (e: React.MouseEvent<HTMLElement>) => void;
  popoverText: string | null | undefined;
  submitText: string;
  downgradeHref?: string;
};

export const ChangePlanButtons = ({
  isDisabled,
  onCancelChangePlan,
  onChangePlan,
  popoverText,
  submitText,
  downgradeHref,
}: ChangePlanButtonsProps) => {
  const size = useSize();

  return (
    <ButtonGroup
      columnSize={size === "small" ? "100%" : "minmax(100px, auto)"}
      justify="end"
    >
      <Button color="secondary" onClick={onCancelChangePlan} size="small">
        Cancel
      </Button>
      <TooltipWrapper content={popoverText}>
        {({ childProps }) => (
          <Button
            {...childProps}
            color="primary"
            disabled={isDisabled}
            {...(downgradeHref ? { href: downgradeHref } : {})}
            isFullWidth={true}
            onClick={onChangePlan}
            size="small"
          >
            {submitText}
          </Button>
        )}
      </TooltipWrapper>
    </ButtonGroup>
  );
};
